// extracted by mini-css-extract-plugin
module.exports = {"terms":"_02712f2b3b--terms--NZA8E","label":"_02712f2b3b--label--xiwmQ","indicator":"_02712f2b3b--indicator--kSM4u","rate":"_02712f2b3b--rate--nlozl"};